import CustomImage from '../custom-image/CustomImage';
import IconUI from '../icon/IconUI';
import CardWrapper from './CardWrapper';

export default function CardStaff({
  card,
  category,
  colorIndex,
  onOpenDeepDive,
}) {
  if (!card) return null;

  const interactive = card.hasDeepDive && typeof onOpenDeepDive === 'function';
  const hasImage = Boolean(card.image?.sourceUrl);

  const inner = (
    <>
      <div className="cardStaff-media colorDynamicBg">
        {hasImage ? (
          <CustomImage
            image={card.image}
            fill={true}
            sizes={'(max-width: 768px) 100vw, 33vw'}
          />
        ) : (
          <div className="cardStaff-noImage">
            <svg
              width="106"
              height="98"
              viewBox="0 0 106 98"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M44.6098 14.6399C88.4361 23.9927 97.9255 51.9713 98.0736 70.2475C81.5093 37.972 53.166 31.841 39.5136 31.5474C69.775 37.9268 85.0123 56.7232 91.0716 68.6377C95.919 78.1694 104.281 91.3482 106 97.2462L97.0468 98C93.2278 86.073 92.121 85.9307 90.4733 82.0299C79.0167 82.9673 51.6758 83.1871 32.2327 68.5659C6.88519 49.5048 1.0254 17.8308 0 0C10.8456 10.5787 32.8257 12.1134 44.6098 14.6399Z"
                fill="#F9F9F0"
              />
            </svg>
          </div>
        )}
        {card.hasDeepDive && (
          <IconUI icon={'plus'} theme={'light'} size="small" padding />
        )}
      </div>

      <div className="cardStaff-text">
        {card.heading && (
          <h3 className="cardStaff-heading headingStrong">{card.heading}</h3>
        )}
        {card.subheading && <p className="text--size-s">{card.subheading}</p>}
      </div>
    </>
  );

  return (
    <CardWrapper
      className={`cardStaff${interactive ? ' cardStaff--interactive' : ''}`}
      colorIndex={colorIndex}
    >
      {interactive ? (
        <button
          type="button"
          className="cardStaff-button"
          aria-haspopup="dialog"
          aria-label={`Read more about ${card.heading}`}
          onClick={() => onOpenDeepDive(card)}
        >
          {inner}
        </button>
      ) : (
        inner
      )}
    </CardWrapper>
  );
}
